import { gql } from '@apollo/client';

export default gql`
  mutation fullPointsRedemption(
    $membershipNumber: String!
    $bookingReference: String!
    $origin: String!
    $destination: String!
    $outbound: FullPointsRedemptionJourney!
    $inbound: FullPointsRedemptionJourney
    $quantity: Int!
    $useNewLoyaltySystem: Boolean = false
    $actionBy: String
  ) {
    fullPointsRedemption(
      membershipNumber: $membershipNumber
      bookingReference: $bookingReference
      origin: $origin
      destination: $destination
      outbound: $outbound
      inbound: $inbound
      quantity: $quantity
      useNewLoyaltySystem: $useNewLoyaltySystem
      actionBy: $actionBy
    ) {
      pointsSpent
      activityId
    }
  }
`;
